import React from 'react';
import { IconProps } from '.';

const SvgChange = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m7 2.94 5.03 5.03-1.06 1.06-3.22-3.22V21h-1.5V5.81L3.03 9.03 1.97 7.97 7 2.94ZM17.75 18.19l3.22-3.22 1.06 1.06L17 21.06l-5.03-5.03 1.06-1.06 3.22 3.22V3h1.5v15.19Z'
      />
    </svg>
  );
};

export default SvgChange;
